module.exports = __webpack_public_path__ + "a6c86a9f0a957f5578bd5cd914dd944e.svg";